export enum TransitionTypesEnum {
  FORWARD_CALENDAR = 'FORWARD_CALENDAR',
  SEARCH = 'SEARCH'
}
